module.exports = __webpack_public_path__ + "img/multiplier_3_th.dfbe7faf.png";